	import React, { Component } from 'react';
import { toastr, actions } from 'react-redux-toastr';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, ControlLabel, Form, FormControl, FormGroup, Panel } from 'react-bootstrap';
import map from 'lodash/map';
import MapsDynamic from './MapsDynamic';
import { fitBounds } from './utils';
import SmallLoader from '../../../../components/SmallLoader';
import ManualLocationModal from './ManualLocationModal';
import { get } from '../../../../shared/http';
import { GPS_INTERVALS, I18N } from '../../../../constants';
import {
    calculateBoundsForStops,
    createGPSClusters,
    createStopClusters,
} from '../../../../shared/utils/run';
import {
    silentFetchRun,
    clearErrorMessage,
    deleteManualLocation,
    getIsLocationDeletePending,
    getError,
} from '../../duck';
import './RunToyotaMap.css';


const successToastrOptions = {
    timeOut: 2500,
    icon: 'success',
    removeOnHover: true,
};

const pendingToastrOptions = {
    timeOut: 2500,
    icon: <i style={{ margin: 20 }} className="fa fa-spinner fa-pulse fa-2x fa-fw" />,
    removeOnHover: true,
};

class RunToyotaMap extends Component {

    state = {
        isFetchingGpsLocations: false,
        fittedBounds: null,
        stopClusters: [],
        gpsClusters: [],
        lat: '',
        lng: '',
        mapOptions: { center: null, zoom: null, interval: GPS_INTERVALS.LAST_KNOWN },
        showManualLocationModal: false,
        accessToken: "",        
        route: {},
        isSatelliteView: false,
        gpsInterval: "LAST_KNOWN"
    };


    componentDidMount = () => {

        this.fetchAccessToken();

        const { stops, gpsLocations } = this.props;
        const size = {
            width: this.refs.container.clientWidth, // Map width in pixels
            height: this.refs.container.clientHeight, // Map height in pixels
        };

        const bounds = this.calculateBounds(stops, gpsLocations);
        const fittedBounds = fitBounds(bounds, size);

        const stopClusters = createStopClusters(stops, fittedBounds);
        const isSingleStop = stopClusters.length === 1;

        this.setState({
            fittedBounds,
            gpsClusters: createGPSClusters(gpsLocations, fittedBounds),
            mapOptions: {
                ...this.state.mapOptions,
                center: isSingleStop ? stops[0].latLng : fittedBounds.center,
                zoom: isSingleStop ? 7 : fittedBounds.zoom,
            },
            stopClusters,
            route: { locations: this.fetchLocationsForRoute(stopClusters), mode: 'driving' }
        });
    };

    componentWillReceiveProps = nextProps => {

        if (
            nextProps.stops.length !== this.props.stops.length ||
            nextProps.gpsLocations.length !== this.props.gpsLocations.length
        ) {
            const { stops, gpsLocations } = nextProps;
            const size = {
                width: this.refs.container.clientWidth, // Map width in pixels
                height: this.refs.container.clientHeight, // Map height in pixels
            };

            const bounds = this.calculateBounds(stops, gpsLocations);
            const fittedBounds = fitBounds(bounds, size);
            this.setState({
                gpsClusters: createGPSClusters(gpsLocations, fittedBounds),
                stopClusters: createStopClusters(stops, fittedBounds),
            });
        }
    };

    calculateBounds(stops, gpsLocations) {

        var allMarkers = stops.slice();

        for (let i = 0; i < gpsLocations.length; i++) {
            var gpsLocation = { latLng: { lat: null, lng: null } };
            gpsLocation.latLng.lat = gpsLocations[i].latitude;
            gpsLocation.latLng.lng = gpsLocations[i].longitude;
            allMarkers.push(gpsLocation);
        }
        return calculateBoundsForStops(allMarkers);
    }

    handleAddManualLocation = (lat, lng) => {
        this.setState({
            showManualLocationModal: true,
            lat: lat,
            lng: lng,
        });
    };

    toggleView = () => {
        this.setState({
            isSatelliteView: !this.state.isSatelliteView
        });

        this.renderPage();
    };

    renderPage = () => {
        this.setState({ isFetchingGpsLocations: true });

        //  Here the map is re-rendered after 100 milliseconds
        setTimeout(() => {
            this.setState({ isFetchingGpsLocations: false });
        }, 100);
    };

    handleCloseModal = () => {
        this.setState({
            showManualLocationModal: false,
        });
    };

    fetchAccessToken = () => {

        get("/api/runs/getAccessCode/"+this.props.runId).then(
            response => {
                this.setState({ accessToken: response.accessCode });
            },
            error => {
                toastr.error(error.message || 'Failed to fetch Map Box Access Code...');
            }
        );
    }

    fetchLocationsForRoute = (stopClusters) => {

        const locations = [];
        for (let i = 0; i < stopClusters.length; i++) {
            locations.push([(stopClusters[i].x), (stopClusters[i].y)]);
        }
        // to handle route for single stop scenario
        if(stopClusters.length == 1){
            locations.push([(stopClusters[0].x), (stopClusters[0].y)]);
        }
        return locations;
    }

    handleGpsIntervalChange = e => {
        this.setState({
            isFetchingGpsLocations: true,
            mapOptions: {
                ...this.state.mapOptions,
                [e.target.name]: e.target.value,
            },
        });
        if (GPS_INTERVALS.hasOwnProperty(e.target.value) > -1) {

            this.setState({ gpsInterval: e.target.value })

            get(`/api/runs/${this.props.runId}/gps?type=${e.target.value}`).then(
                response => {
                    const gpsLocations = response.gpsLocations;
                    this.setState(() => ({
                        isFetchingGpsLocations: false,
                        gpsClusters: createGPSClusters(gpsLocations, this.state.fittedBounds)
                    }));
                },
                error => {
                    toastr.error(error.message || 'Failed to fetch GPS locations...');
                    this.setState(() => ({
                        isFetchingGpsLocations: false,
                    }));
                }
            );
        } else {
            console.log('Illegal type provided for GPS locations API call.');
        }
    };

    rightClickAddManualLocation = e => {
        this.handleAddManualLocation(e.lngLat.lat, e.lngLat.lng);
    }

    deleteManualGPSLocation = (gpsLocationId, runId) => {
        this.props.toastr.add({
            id: 'deletingManualLocationPending',
            type: 'info',
            title: 'Deleting manual location...',
            position: 'top-right',
            attention: true,
            message: '',
            options: { pendingToastrOptions },
        });
        let data = {
            gpsLocationId: gpsLocationId,
            runId: runId,
        };
        this.props
            .deleteManualLocation(data)
            .then(() => {
                this.props.toastr.remove('deletingManualLocationPending');
                return this.props.toastr.add({
                    id: 'deletedManualLocation', // If not provided we will add one.
                    type: 'success',
                    title: 'Successfully deleted manual location.',
                    position: 'top-right', // This will override the global props position.
                    attention: true, // This will add a shadow like the confirm method.
                    options: { successToastrOptions },
                });
            })
            .then(() => {
                setTimeout(() => {
                    this.fetchGpsLocations('deletedManualLocation');
                }, 100);
            });
    };

    fetchGpsLocations = (type) => {
        get(`/api/runs/${this.props.runId}/gps?type=` + this.state.gpsInterval).then(
            response => {
                const gpsLocations = response.gpsLocations;
                this.props.toastr.remove(type);
                this.setState(() => ({
                    isFetchingGpsLocations: false,
                    gpsClusters: createGPSClusters(gpsLocations, this.state.fittedBounds)                        
                }));
                this.renderPage();
            },
            error => {
                toastr.error(error.message || 'Failed to fetch GPS locations...');
                this.setState(() => ({
                    isFetchingGpsLocations: false,
                }));
            }
        );
    };

    render() {
        const { runId, lastGpsLocation } = this.props;
        const { isFetchingGpsLocations, stopClusters, gpsClusters, mapOptions, accessToken, route, isSatelliteView } = this.state;
        const viewStyle = isSatelliteView ? 'mapbox/satellite-streets-v11' : null;

        // in case of a map with no markers loading belgium as the center point of the map
        const countryCode = stopClusters.length === 0 ? 'be' : '';   
        const routeForMap = stopClusters.length === 0 ?  null : route;   
        const maxZoom = stopClusters.length <= 1 ? 13 : null;

        if (accessToken === "" || isFetchingGpsLocations) {
            return <div className="map-inner-container" ref="container">Loading...</div>;
        }


        return (
            <div className="map-container">
                <div className="wrap">
                    <Button style={{ width: "50%" }} onClick={this.handleAddManualLocation}>
                        Add Manual Location
                </Button>
                    <Button style={{ width: "50%" }} onClick={this.toggleView}>
                        Map/Satellite View
                </Button>
                </div>
                <div className="map-inner-container" ref="container">
                    <MapsDynamic
                            className='mapStyle'
                            accessToken={accessToken}
                            fitToBounds={true}
                            zoom={mapOptions.zoom}
                            maxZoom={maxZoom}
                            zoomControl={true}                            
                            countryCode={countryCode}
                            gpsClusters={gpsClusters}
                            stopClusters={stopClusters}
                            lastGpsLocation={lastGpsLocation}
                            style={viewStyle}
                            deleteManualGPSLocation={this.deleteManualGPSLocation}
                            runId={runId}
                            resizeToBounds={true}
                            rightClick={this.rightClickAddManualLocation}   
                            route={routeForMap}                         
                        />
                </div>
                <Panel className="map-options">
                    <Form inline>
                        <FormGroup controlId="abnormalityType">
                            <ControlLabel style={{ marginRight: 20 }}>GPS interval: </ControlLabel>
                            {isFetchingGpsLocations ? (
                                <SmallLoader noMargin tiny />
                            ) : (
                                    <FormControl
                                        componentClass="select"
                                        name="interval"
                                        value={mapOptions.interval}
                                        onChange={this.handleGpsIntervalChange}
                                    >
                                        {map(GPS_INTERVALS, i => (
                                            <option key={i} value={i}>
                                                {I18N.GPS_INTERVAL[i]}
                                            </option>
                                        ))}
                                    </FormControl>
                                )}
                        </FormGroup>
                    </Form>
                </Panel>
                {this.state.showManualLocationModal && (
                    <ManualLocationModal
                        runId={runId}
                        lat={this.state.lat}
                        lng={this.state.lng}
                        onClose={this.handleCloseModal}
                        renderPage={this.renderPage}
                        fetchGpsLocations={this.fetchGpsLocations}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    isPending: getIsLocationDeletePending(state),
    isRejected: getError(state),
});

const mapDispatchToProps = dispatch => ({
    deleteManualLocation: bindActionCreators(deleteManualLocation, dispatch),
    toastr: bindActionCreators(actions, dispatch),
    loadRun: bindActionCreators(silentFetchRun, dispatch),
    clearErrorMessage: bindActionCreators(clearErrorMessage, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(RunToyotaMap);
